<div class="condition">
  <div class="conditions-header">
    <span class="title">{{ 'FilterOptionsTitle' | translate }}</span>
    <div class="select" (click)="$event.stopPropagation()">
      <mat-select
        appearance="outline"
        [placeholder]="'FilterOptionsSelectPlaceholder' | translate"
        [multiple]="multiple"
        [(ngModel)]="value"
        (ngModelChange)="onValueChange($event)"
        name="item"
        class="operator"
      >
        <mat-option *ngIf="!multiple" [value]="null">{{ 'FilterOptionsAll' | translate }}</mat-option>
        <mat-option *ngFor="let item of values" [value]="item.value">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div class="conditions-clear" (click)="$event.stopPropagation()">
    <mat-icon
      (click)="clearFilter()"
      class="clear"
      svgIcon="custom_filter_clear"
    >clear</mat-icon>
  </div>
</div>

<div class="filters" (click)="$event.stopPropagation()">
  <div class="filter-item" *ngFor="let item of filters; let i = index">
    {{ item.value }}
    <mat-icon (click)="removeFilter(i)">close</mat-icon>
  </div>
</div>
